require('../../modules/es6.reflect.construct');
module.exports = require('../../modules/_core').Reflect.construct;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/construct.js
// module id = 798
// module chunks = 0